import React from 'react';
import { Button } from '../ui/button';
import { Plus, Trash2, Edit2 } from 'lucide-react';

export function CategoriesTab({ openCategoryForm, categories, handleDeleteCategory }) {
  return (
    <>
      <div className="flex justify-end mb-4">
        <Button onClick={() => openCategoryForm(null)} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="admin-add-category-btn">
          <Plus className="w-4 h-4 mr-2" /> Kategori Ekle
        </Button>
      </div>
      <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-50">
        {categories.map(c => (
          <div key={c.slug} data-testid={`admin-category-${c.slug}`} className="flex items-center gap-4 px-4 py-3">
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-slate-800">{c.name} <span className="text-xs text-slate-400 font-normal">/{c.slug}</span></div>
              <div className="text-xs text-slate-500 truncate">{c.description || '—'}</div>
              <div className="text-xs text-slate-400 mt-0.5">{c.topic_count || 0} konu · sıra: {c.order || 0}</div>
            </div>
            <div className="flex gap-1 shrink-0">
              <button onClick={() => openCategoryForm(c)} className="p-1.5 rounded-lg text-slate-500 hover:bg-slate-100" data-testid={`admin-edit-cat-${c.slug}`}><Edit2 className="w-3.5 h-3.5" /></button>
              <button onClick={() => handleDeleteCategory(c.slug)} className="p-1.5 rounded-lg text-red-500 hover:bg-red-50" data-testid={`admin-delete-cat-${c.slug}`}><Trash2 className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
        {categories.length === 0 && <div className="text-center py-8 text-slate-500">Kategori yok</div>}
      </div>
    </>
  );
}
